export default __webpack_public_path__ + "static/media/splash.aa0199cd.gif";